const ToastMessage = {
  successList: {
    Login: "Login Successfully",
    checkOut: "ClockOuted successfully",
    checkIn: "ClockIn Successfully",
  },
  errorList: {
    checkOut: "Something went Wrong",
    checkIn: "Something went wrong",
    noEmployee: "Please select any employee to be added",
    duplicateDocument: "This document is already added in the list",
    duplicateEmployee: "This employee is already added in the list",
    noEmployeeForTheDepartment: "There is no epmloyee in the selected department",
    forbidden: "You are not authorized to perform this action"

  },
};

export default ToastMessage;
